<template>
  <div>
    <v-layout row wrap>
      <v-flex xs6 md2>
        <v-flex>
          <h4>{{ title }}</h4>
        </v-flex>
        <v-flex v-for="menu in menus" :key="menu.title"><a :href="menu.link">{{menu.title}}</a> </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    menus: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
};
</script>